module.exports = __webpack_public_path__ + "img/marker.54b56756.png";